import { createRequest } from "helpers/tools";

export const deleteDestination = async (id) => {
    return await createRequest({
        suffix: `lead/destinations/${id}`,
        method: "delete",
        handleError: false,
    });
};

export const deleteDestinationWithConnection = async (connection_id, destination_id) => {
    return await createRequest({
        suffix: `lead/connection/${connection_id}/destinations/${destination_id}`,
        method: "delete",
        handleError: false,
    });
};
